module.exports = __webpack_public_path__ + "static/media/hg659.5ffee65a.png";


/*****************
 ** WEBPACK FOOTER
 ** ./src/assets/hg659.png
 ** module id = 1303
 ** module chunks = 0
 **/